var map = {
	"./chimaeras/callorhinchidae/callorhinchus-callorynchus.js": [
		23817,
		23817
	],
	"./chimaeras/callorhinchidae/callorhinchus-capensis.js": [
		29908,
		29908
	],
	"./chimaeras/callorhinchidae/callorhinchus-milii.js": [
		19373,
		19373
	],
	"./chimaeras/chimaeridae/chimaera-fulva.js": [
		76612,
		76612
	],
	"./chimaeras/chimaeridae/chimaera-monstrosa.js": [
		47500,
		47500
	],
	"./chimaeras/chimaeridae/chimaera-phantasma.js": [
		63894,
		63894
	],
	"./chimaeras/chimaeridae/hydrolagus-africanus.js": [
		5429,
		5429
	],
	"./chimaeras/chimaeridae/hydrolagus-alberti.js": [
		76640,
		76640
	],
	"./chimaeras/chimaeridae/hydrolagus-colliei.js": [
		5607,
		5607
	],
	"./chimaeras/chimaeridae/hydrolagus-lemures.js": [
		9589,
		9589
	],
	"./chimaeras/chimaeridae/hydrolagus-novaezealandiae.js": [
		70252,
		70252
	],
	"./chimaeras/rhinochimaeridae/harriotta-raleighana.js": [
		93489,
		93489
	],
	"./chimaeras/rhinochimaeridae/neoharriotta-pinnata.js": [
		32150,
		32150
	],
	"./chimaeras/rhinochimaeridae/rhinochimaera-pacifica.js": [
		92748,
		92748
	],
	"./manifest.js": [
		93325,
		93325
	],
	"./rays/myliobatiformes/dasyatidae/dasyatis-americana.js": [
		25962,
		25962
	],
	"./rays/myliobatiformes/dasyatidae/dasyatis-brevicaudata.js": [
		36319,
		36319
	],
	"./rays/myliobatiformes/dasyatidae/dasyatis-brevis.js": [
		55568,
		55568
	],
	"./rays/myliobatiformes/dasyatidae/dasyatis-centroura.js": [
		83644,
		83644
	],
	"./rays/myliobatiformes/dasyatidae/dasyatis-chrysonota.js": [
		62436,
		62436
	],
	"./rays/myliobatiformes/dasyatidae/dasyatis-longa.js": [
		50749,
		50749
	],
	"./rays/myliobatiformes/dasyatidae/dasyatis-margarita.js": [
		41263,
		41263
	],
	"./rays/myliobatiformes/dasyatidae/dasyatis-margaritella.js": [
		19796,
		19796
	],
	"./rays/myliobatiformes/dasyatidae/dasyatis-sabina.js": [
		15563,
		15563
	],
	"./rays/myliobatiformes/dasyatidae/dasyatis-say.js": [
		12846,
		12846
	],
	"./rays/myliobatiformes/dasyatidae/dasyatis-ushiei.js": [
		71699,
		71699
	],
	"./rays/myliobatiformes/dasyatidae/dasyatis-zugei.js": [
		46928,
		54071
	],
	"./rays/myliobatiformes/dasyatidae/himantura-astra.js": [
		28585,
		28585
	],
	"./rays/myliobatiformes/dasyatidae/himantura-fai.js": [
		45698,
		45698
	],
	"./rays/myliobatiformes/dasyatidae/himantura-gerrardi.js": [
		44822,
		44822
	],
	"./rays/myliobatiformes/dasyatidae/himantura-granulata.js": [
		42767,
		42767
	],
	"./rays/myliobatiformes/dasyatidae/himantura-imbricata.js": [
		29815,
		29815
	],
	"./rays/myliobatiformes/dasyatidae/himantura-jenkinsii.js": [
		12449,
		12449
	],
	"./rays/myliobatiformes/dasyatidae/himantura-kittipongi.js": [
		65497,
		65497
	],
	"./rays/myliobatiformes/dasyatidae/himantura-leoparda.js": [
		96139,
		96139
	],
	"./rays/myliobatiformes/dasyatidae/himantura-lobistoma.js": [
		75977,
		75977
	],
	"./rays/myliobatiformes/dasyatidae/himantura-oxyrhyncha.js": [
		41617,
		41617
	],
	"./rays/myliobatiformes/dasyatidae/himantura-pastinacoides.js": [
		73546,
		73546
	],
	"./rays/myliobatiformes/dasyatidae/himantura-polylepis.js": [
		3795,
		3795
	],
	"./rays/myliobatiformes/dasyatidae/himantura-signifer.js": [
		23311,
		23311
	],
	"./rays/myliobatiformes/dasyatidae/himantura-uarnacoides.js": [
		40805,
		40805
	],
	"./rays/myliobatiformes/dasyatidae/himantura-uarnak.js": [
		62337,
		62337
	],
	"./rays/myliobatiformes/dasyatidae/himantura-undulata.js": [
		26823,
		26823
	],
	"./rays/myliobatiformes/dasyatidae/himantura-walga.js": [
		67641,
		67641
	],
	"./rays/myliobatiformes/dasyatidae/neotrygon-kuhlii.js": [
		59246,
		59246
	],
	"./rays/myliobatiformes/dasyatidae/neotrygon-ningalooensis.js": [
		63018,
		63018
	],
	"./rays/myliobatiformes/dasyatidae/neotrygon-picta.js": [
		4708,
		4708
	],
	"./rays/myliobatiformes/dasyatidae/pastinachus-atrus.js": [
		28942,
		28942
	],
	"./rays/myliobatiformes/dasyatidae/pastinachus-gracilicaudus.js": [
		44040,
		44040
	],
	"./rays/myliobatiformes/dasyatidae/pastinachus-sephen.js": [
		50302,
		50302
	],
	"./rays/myliobatiformes/dasyatidae/pastinachus-solocirostris.js": [
		1131,
		1131
	],
	"./rays/myliobatiformes/dasyatidae/pastinachus-stellurostris.js": [
		24928,
		24928
	],
	"./rays/myliobatiformes/dasyatidae/pteroplatytrygon-violacea.js": [
		3303,
		3303
	],
	"./rays/myliobatiformes/dasyatidae/taeniura-grabata.js": [
		85266,
		85266
	],
	"./rays/myliobatiformes/dasyatidae/taeniura-lymma.js": [
		20675,
		20675
	],
	"./rays/myliobatiformes/dasyatidae/taeniura-meyeni.js": [
		50036,
		50036
	],
	"./rays/myliobatiformes/dasyatidae/urogymnus-asperrimus.js": [
		67075,
		67075
	],
	"./rays/myliobatiformes/gymnuridae/gymnura-altavela.js": [
		21031,
		21031
	],
	"./rays/myliobatiformes/gymnuridae/gymnura-australis.js": [
		22824,
		22824
	],
	"./rays/myliobatiformes/gymnuridae/gymnura-crebripunctata.js": [
		18255,
		18255
	],
	"./rays/myliobatiformes/gymnuridae/gymnura-marmorata.js": [
		808,
		808
	],
	"./rays/myliobatiformes/gymnuridae/gymnura-micrura.js": [
		43009,
		43009
	],
	"./rays/myliobatiformes/gymnuridae/gymnura-poecilura.js": [
		59566,
		59566
	],
	"./rays/myliobatiformes/gymnuridae/gymnura-zonura.js": [
		58024,
		58024
	],
	"./rays/myliobatiformes/hexatrygon-bickelli.js": [
		90423,
		90423
	],
	"./rays/myliobatiformes/himantura-schmardae.js": [
		44850,
		44850
	],
	"./rays/myliobatiformes/megatrygon-microps.js": [
		68654,
		68654
	],
	"./rays/myliobatiformes/mobulidae/mobula-birostris.js": [
		59727,
		59727
	],
	"./rays/myliobatiformes/mobulidae/mobula-hypostoma.js": [
		62014,
		62014
	],
	"./rays/myliobatiformes/mobulidae/mobula-japanica.js": [
		29020,
		29020
	],
	"./rays/myliobatiformes/mobulidae/mobula-kuhlii.js": [
		34107,
		34107
	],
	"./rays/myliobatiformes/mobulidae/mobula-munkiana.js": [
		32054,
		32054
	],
	"./rays/myliobatiformes/mobulidae/mobula-thurstoni.js": [
		86411,
		86411
	],
	"./rays/myliobatiformes/myliobatidae/aetobatus-flagellum.js": [
		6616,
		6616
	],
	"./rays/myliobatiformes/myliobatidae/aetobatus-laticeps.js": [
		88043,
		88043
	],
	"./rays/myliobatiformes/myliobatidae/aetobatus-narinari.js": [
		56673,
		56673
	],
	"./rays/myliobatiformes/myliobatidae/aetobatus-ocellatus.js": [
		10314,
		10314
	],
	"./rays/myliobatiformes/myliobatidae/aetomylaeus-maculatus.js": [
		95522,
		95522
	],
	"./rays/myliobatiformes/myliobatidae/aetomylaeus-milvus.js": [
		92655,
		92655
	],
	"./rays/myliobatiformes/myliobatidae/aetomylaeus-nichofii.js": [
		92229,
		92229
	],
	"./rays/myliobatiformes/myliobatidae/aetomylaeus-vespertilio.js": [
		40362,
		40362
	],
	"./rays/myliobatiformes/myliobatidae/myliobatis-aquila.js": [
		90241,
		90241
	],
	"./rays/myliobatiformes/myliobatidae/myliobatis-australis.js": [
		69294,
		69294
	],
	"./rays/myliobatiformes/myliobatidae/myliobatis-californica.js": [
		82829,
		82829
	],
	"./rays/myliobatiformes/myliobatidae/myliobatis-freminvillei.js": [
		28893,
		28893
	],
	"./rays/myliobatiformes/myliobatidae/myliobatis-longirostris.js": [
		20646,
		20646
	],
	"./rays/myliobatiformes/myliobatidae/myliobatis-tobijei.js": [
		97569,
		97569
	],
	"./rays/myliobatiformes/myliobatidae/pteromylaeus-bovinus.js": [
		19687,
		19687
	],
	"./rays/myliobatiformes/paratrygon-aiereba.js": [
		86928,
		86928
	],
	"./rays/myliobatiformes/plesiobatis-daviesi.js": [
		7305,
		7305
	],
	"./rays/myliobatiformes/potamotrygon-motoro.js": [
		8123,
		8123
	],
	"./rays/myliobatiformes/rhinopteridae/rhinoptera-bonasus.js": [
		57181,
		57181
	],
	"./rays/myliobatiformes/rhinopteridae/rhinoptera-javanica.js": [
		12901,
		12901
	],
	"./rays/myliobatiformes/rhinopteridae/rhinoptera-jayakari.js": [
		56772,
		56772
	],
	"./rays/myliobatiformes/rhinopteridae/rhinoptera-neglecta.js": [
		50111,
		50111
	],
	"./rays/myliobatiformes/rhinopteridae/rhinoptera-steindachneri.js": [
		87893,
		87893
	],
	"./rays/myliobatiformes/trygonoptera-imitata.js": [
		83707,
		83707
	],
	"./rays/myliobatiformes/trygonoptera-ovalis.js": [
		42103,
		42103
	],
	"./rays/myliobatiformes/trygonoptera-personata.js": [
		87555,
		87555
	],
	"./rays/myliobatiformes/trygonoptera-testacea.js": [
		52363,
		52363
	],
	"./rays/myliobatiformes/urolophus/urolophus-bucculentus.js": [
		7362,
		7362
	],
	"./rays/myliobatiformes/urolophus/urolophus-cruciatus.js": [
		2592,
		2592
	],
	"./rays/myliobatiformes/urolophus/urolophus-expansus.js": [
		32634,
		32634
	],
	"./rays/myliobatiformes/urolophus/urolophus-flavomosaicus.js": [
		79842,
		79842
	],
	"./rays/myliobatiformes/urolophus/urolophus-kapalensis.js": [
		66214,
		66214
	],
	"./rays/myliobatiformes/urolophus/urolophus-lobatus.js": [
		70398,
		70398
	],
	"./rays/myliobatiformes/urolophus/urolophus-paucimaculatus.js": [
		19642,
		19642
	],
	"./rays/myliobatiformes/urolophus/urolophus-viridis.js": [
		69664,
		69664
	],
	"./rays/myliobatiformes/urolophus/urolophus-westraliensis.js": [
		92510,
		92510
	],
	"./rays/myliobatiformes/urotrygonidae/urobatis-concentricus.js": [
		45633,
		45633
	],
	"./rays/myliobatiformes/urotrygonidae/urobatis-halleri.js": [
		15511,
		15511
	],
	"./rays/myliobatiformes/urotrygonidae/urobatis-jamaicensis.js": [
		54750,
		54750
	],
	"./rays/myliobatiformes/urotrygonidae/urobatis-maculatus.js": [
		2889,
		2889
	],
	"./rays/myliobatiformes/urotrygonidae/urotrygon-rogersi.js": [
		23275,
		23275
	],
	"./rays/myliobatiformes/urotrygonidae/urotrygon-simulatrix.js": [
		34649,
		34649
	],
	"./rays/platyrhinidae/platyrhinoidis-triseriata.js": [
		60226,
		60226
	],
	"./rays/rajiformes/arhynchobatidae/arhynchobatis-asperrimus.js": [
		32185,
		32185
	],
	"./rays/rajiformes/arhynchobatidae/atlantoraja-castelnaui.js": [
		74007,
		74007
	],
	"./rays/rajiformes/arhynchobatidae/atlantoraja-cyclophora.js": [
		58718,
		58718
	],
	"./rays/rajiformes/arhynchobatidae/atlantoraja-platana.js": [
		18940,
		18940
	],
	"./rays/rajiformes/arhynchobatidae/bathyraja-aleutica.js": [
		5886,
		5886
	],
	"./rays/rajiformes/arhynchobatidae/bathyraja-bergi.js": [
		72678,
		72678
	],
	"./rays/rajiformes/arhynchobatidae/bathyraja-brachyurops.js": [
		33926,
		33926
	],
	"./rays/rajiformes/arhynchobatidae/bathyraja-griseocauda.js": [
		21674,
		21674
	],
	"./rays/rajiformes/arhynchobatidae/bathyraja-interrupta.js": [
		22832,
		22832
	],
	"./rays/rajiformes/arhynchobatidae/bathyraja-kincaidi.js": [
		42163,
		42163
	],
	"./rays/rajiformes/arhynchobatidae/bathyraja-maculata.js": [
		32990,
		32990
	],
	"./rays/rajiformes/arhynchobatidae/bathyraja-mariposa.js": [
		54559,
		54559
	],
	"./rays/rajiformes/arhynchobatidae/bathyraja-minispinosa.js": [
		18915,
		18915
	],
	"./rays/rajiformes/arhynchobatidae/bathyraja-pallida.js": [
		15514,
		15514
	],
	"./rays/rajiformes/arhynchobatidae/bathyraja-parmifera.js": [
		93079,
		93079
	],
	"./rays/rajiformes/arhynchobatidae/bathyraja-scaphiops.js": [
		16532,
		16532
	],
	"./rays/rajiformes/arhynchobatidae/bathyraja-shuntovi.js": [
		72353,
		72353
	],
	"./rays/rajiformes/arhynchobatidae/bathyraja-smirnovi.js": [
		45454,
		45454
	],
	"./rays/rajiformes/arhynchobatidae/bathyraja-taranetzi.js": [
		44866,
		44866
	],
	"./rays/rajiformes/arhynchobatidae/bathyraja-trachura.js": [
		20864,
		20864
	],
	"./rays/rajiformes/arhynchobatidae/bathyraja-violacea.js": [
		35880,
		35880
	],
	"./rays/rajiformes/arhynchobatidae/brochiraja-albilabiata.js": [
		51131,
		51131
	],
	"./rays/rajiformes/arhynchobatidae/brochiraja-asperula.js": [
		80136,
		80136
	],
	"./rays/rajiformes/arhynchobatidae/brochiraja-leviveneta.js": [
		62709,
		62709
	],
	"./rays/rajiformes/arhynchobatidae/brochiraja-microspinifera.js": [
		19793,
		19793
	],
	"./rays/rajiformes/arhynchobatidae/brochiraja-spinifera.js": [
		41737,
		41737
	],
	"./rays/rajiformes/arhynchobatidae/insentiraja-subtilispinosa.js": [
		46074,
		46074
	],
	"./rays/rajiformes/arhynchobatidae/irolita-waitii.js": [
		56729,
		56729
	],
	"./rays/rajiformes/arhynchobatidae/notoraja-azurea.js": [
		43316,
		43316
	],
	"./rays/rajiformes/arhynchobatidae/pavoraja-alleni.js": [
		12454,
		12454
	],
	"./rays/rajiformes/arhynchobatidae/pavoraja-nitida.js": [
		56075,
		56075
	],
	"./rays/rajiformes/arhynchobatidae/rhinoraja-albomaculata.js": [
		54953,
		54953
	],
	"./rays/rajiformes/arhynchobatidae/rhinoraja-macloviana.js": [
		78866,
		78866
	],
	"./rays/rajiformes/arhynchobatidae/rhinoraja-magellanica.js": [
		43928,
		43928
	],
	"./rays/rajiformes/arhynchobatidae/rhinoraja-multispinis.js": [
		67441,
		67441
	],
	"./rays/rajiformes/arhynchobatidae/rhinoraja-taranetzi.js": [
		89294,
		89294
	],
	"./rays/rajiformes/arhynchobatidae/rioraja-agassizii.js": [
		21437,
		21437
	],
	"./rays/rajiformes/arhynchobatidae/sympterygia-acuta.js": [
		25740,
		25740
	],
	"./rays/rajiformes/arhynchobatidae/sympterygia-bonapartii.js": [
		24229,
		24229
	],
	"./rays/rajiformes/cruriraja-hulleyi.js": [
		32113,
		32113
	],
	"./rays/rajiformes/rajidae/amblyraja-badia.js": [
		45130,
		45130
	],
	"./rays/rajiformes/rajidae/amblyraja-doellojuradoi.js": [
		12229,
		12229
	],
	"./rays/rajiformes/rajidae/amblyraja-hyperborea.js": [
		1676,
		1676
	],
	"./rays/rajiformes/rajidae/amblyraja-jenseni.js": [
		35766,
		35766
	],
	"./rays/rajiformes/rajidae/amblyraja-radiata.js": [
		19640,
		19640
	],
	"./rays/rajiformes/rajidae/dipturus-australis.js": [
		60541,
		60541
	],
	"./rays/rajiformes/rajidae/dipturus-batis.js": [
		20059,
		20059
	],
	"./rays/rajiformes/rajidae/dipturus-cerva.js": [
		39715,
		39715
	],
	"./rays/rajiformes/rajidae/dipturus-confusus.js": [
		63973,
		63973
	],
	"./rays/rajiformes/rajidae/dipturus-gudgeri.js": [
		31152,
		31152
	],
	"./rays/rajiformes/rajidae/dipturus-healdi.js": [
		62938,
		62938
	],
	"./rays/rajiformes/rajidae/dipturus-innominatus.js": [
		78584,
		78584
	],
	"./rays/rajiformes/rajidae/dipturus-laevis.js": [
		44417,
		44417
	],
	"./rays/rajiformes/rajidae/dipturus-leptocauda.js": [
		35274,
		35274
	],
	"./rays/rajiformes/rajidae/dipturus-linteus.js": [
		4344,
		4344
	],
	"./rays/rajiformes/rajidae/dipturus-oxyrhinchus.js": [
		84062,
		84062
	],
	"./rays/rajiformes/rajidae/dipturus-pullopunctatus.js": [
		56696,
		55304
	],
	"./rays/rajiformes/rajidae/dipturus-springeri.js": [
		35024,
		35024
	],
	"./rays/rajiformes/rajidae/dipturus-tengu.js": [
		32408,
		32408
	],
	"./rays/rajiformes/rajidae/dipturus-trachyderma.js": [
		50901,
		50901
	],
	"./rays/rajiformes/rajidae/leucoraja-erinacea.js": [
		74910,
		74910
	],
	"./rays/rajiformes/rajidae/leucoraja-garmani.js": [
		85516,
		85516
	],
	"./rays/rajiformes/rajidae/leucoraja-ocellata.js": [
		91486,
		91486
	],
	"./rays/rajiformes/rajidae/okamejei-jensenae.js": [
		27312,
		27312
	],
	"./rays/rajiformes/rajidae/raja-asterias.js": [
		12978,
		12978
	],
	"./rays/rajiformes/rajidae/raja-clavata.js": [
		56523,
		56523
	],
	"./rays/rajiformes/rajidae/raja-eglanteria.js": [
		97433,
		97433
	],
	"./rays/rajiformes/rajidae/raja-miraletus.js": [
		35786,
		35786
	],
	"./rays/rajiformes/rajidae/raja-montagui.js": [
		26103,
		26103
	],
	"./rays/rajiformes/rajidae/raja-straeleni.js": [
		67609,
		67609
	],
	"./rays/rajiformes/rajidae/raja-velezi.js": [
		97382,
		97382
	],
	"./rays/rajiformes/rajidae/rajella-caudaspinosa.js": [
		17545,
		17545
	],
	"./rays/rajiformes/rajidae/rajella-fyllae.js": [
		46690,
		46690
	],
	"./rays/rajiformes/rajidae/rajella-kukujevi.js": [
		28354,
		28354
	],
	"./rays/rajiformes/rajidae/rajella-leopardus.js": [
		43586,
		43586
	],
	"./rays/rajiformes/rajidae/rostroraja-alba.js": [
		117,
		117
	],
	"./rays/rajiformes/rajidae/spiniraja-whitleyi.js": [
		26557,
		26557
	],
	"./rays/rajiformes/rajidae/zearaja-chilensis.js": [
		93716,
		93716
	],
	"./rays/rajiformes/rajidae/zearaja-nasuta.js": [
		28194,
		28194
	],
	"./rays/rajiformes/sinobatis-bulbicauda.js": [
		37216,
		37216
	],
	"./rays/rhinopristiformes/anoxypristis-cuspidata.js": [
		11559,
		11559
	],
	"./rays/rhinopristiformes/aptychotrema-rostrata.js": [
		54931,
		54931
	],
	"./rays/rhinopristiformes/aptychotrema-vincentiana.js": [
		52017,
		52017
	],
	"./rays/rhinopristiformes/glaucostegus-thouin.js": [
		71909,
		71909
	],
	"./rays/rhinopristiformes/glaucostegus-typus.js": [
		63013,
		63013
	],
	"./rays/rhinopristiformes/pristis-clavata.js": [
		86815,
		86815
	],
	"./rays/rhinopristiformes/pristis-pectinata.js": [
		18369,
		18369
	],
	"./rays/rhinopristiformes/pristis-pristis.js": [
		91083,
		91083
	],
	"./rays/rhinopristiformes/pristis-zijsron.js": [
		62322,
		62322
	],
	"./rays/rhinopristiformes/rhina-ancylostoma.js": [
		20570,
		20570
	],
	"./rays/rhinopristiformes/rhinobatos-annulatus.js": [
		89625,
		89625
	],
	"./rays/rhinopristiformes/rhinobatos-cemiculus.js": [
		98251,
		98251
	],
	"./rays/rhinopristiformes/rhinobatos-formosensis.js": [
		69787,
		69787
	],
	"./rays/rhinopristiformes/rhinobatos-glaucostigma.js": [
		7159,
		7159
	],
	"./rays/rhinopristiformes/rhinobatos-productus.js": [
		42761,
		42761
	],
	"./rays/rhinopristiformes/rhinobatos-rhinobatos.js": [
		49145,
		49145
	],
	"./rays/rhinopristiformes/rhinobatos-schlegelii.js": [
		69216,
		69216
	],
	"./rays/rhinopristiformes/rhynchobatus-australiae.js": [
		75677,
		75677
	],
	"./rays/rhinopristiformes/rhynchobatus-laevis.js": [
		77555,
		77555
	],
	"./rays/rhinopristiformes/rhynchobatus-palpebratus.js": [
		57110,
		57110
	],
	"./rays/rhinopristiformes/trygonorrhina-dumerilii.js": [
		97209,
		97209
	],
	"./rays/rhinopristiformes/zanobatus-schoenleinii.js": [
		61528,
		61528
	],
	"./rays/rhinopristiformes/zapteryx-exasperata.js": [
		87327,
		87327
	],
	"./rays/torpediniformes/narcine-entemedor.js": [
		79494,
		79494
	],
	"./rays/torpediniformes/narcine-lasti.js": [
		75268,
		75268
	],
	"./rays/torpediniformes/narcine-tasmaniensis.js": [
		5923,
		5923
	],
	"./rays/torpediniformes/narke-capensis.js": [
		64009,
		64009
	],
	"./rays/torpediniformes/torpedo-fuscomaculata.js": [
		58349,
		58349
	],
	"./rays/torpediniformes/torpedo-mackayana.js": [
		87253,
		87253
	],
	"./rays/torpediniformes/torpedo-macneilli.js": [
		28341,
		28341
	],
	"./rays/torpediniformes/torpedo-marmorata.js": [
		7542,
		7542
	],
	"./rays/torpediniformes/torpedo-nobiliana.js": [
		60440,
		60440
	],
	"./rays/torpediniformes/torpedo-sinuspersici.js": [
		84752,
		84752
	],
	"./rays/torpediniformes/torpedo-torpedo.js": [
		67657,
		67657
	],
	"./rays/torpediniformes/typhlonarke-aysoni.js": [
		61458,
		61458
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-acronotus.js": [
		54121,
		54121
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-albimarginatus.js": [
		55757,
		55757
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-altimus.js": [
		89270,
		89270
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-amblyrhynchoides.js": [
		10741,
		10741
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-amblyrhynchos.js": [
		84243,
		84243
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-amboinensis.js": [
		2449,
		2449
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-borneensis.js": [
		94884,
		94884
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-brachyurus.js": [
		34726,
		34726
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-brevipinna.js": [
		90740,
		90740
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-cautus.js": [
		61063,
		61063
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-dussumieri.js": [
		50666,
		50666
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-falciformis.js": [
		12080,
		12080
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-fitzroyensis.js": [
		18571,
		18571
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-galapagensis.js": [
		28170,
		28170
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-isodon.js": [
		5799,
		5799
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-leiodon.js": [
		48989,
		48989
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-leucas.js": [
		65032,
		65032
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-limbatus.js": [
		40754,
		40754
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-longimanus.js": [
		79923,
		79923
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-macloti.js": [
		13308,
		13308
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-melanopterus.js": [
		96237,
		96237
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-obscurus.js": [
		93630,
		93630
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-perezii.js": [
		10495,
		10495
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-plumbeus.js": [
		35517,
		35517
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-porosus.js": [
		27273,
		27273
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-sealei.js": [
		76289,
		76289
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-signatus.js": [
		1306,
		1306
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-sorrah.js": [
		61950,
		22961
	],
	"./sharks/carcharhiniformes/carcharhinidae/carcharhinus-tilstoni.js": [
		26582,
		26582
	],
	"./sharks/carcharhiniformes/carcharhinidae/glyphis-gangeticus.js": [
		18078,
		18078
	],
	"./sharks/carcharhiniformes/carcharhinidae/glyphis-garricki.js": [
		30897,
		30897
	],
	"./sharks/carcharhiniformes/carcharhinidae/glyphis-glyphis.js": [
		75539,
		75539
	],
	"./sharks/carcharhiniformes/carcharhinidae/isogomphodon-oxyrhynchus.js": [
		85478,
		85478
	],
	"./sharks/carcharhiniformes/carcharhinidae/lamiopsis-temminckii.js": [
		29335,
		29335
	],
	"./sharks/carcharhiniformes/carcharhinidae/lamiopsis-tephrodes.js": [
		8187,
		8187
	],
	"./sharks/carcharhiniformes/carcharhinidae/loxodon-macrorhinus.js": [
		47510,
		47510
	],
	"./sharks/carcharhiniformes/carcharhinidae/nasolamia-velox.js": [
		50681,
		50681
	],
	"./sharks/carcharhiniformes/carcharhinidae/negaprion-acutidens.js": [
		27390,
		27390
	],
	"./sharks/carcharhiniformes/carcharhinidae/negaprion-brevirostris.js": [
		46855,
		46855
	],
	"./sharks/carcharhiniformes/carcharhinidae/prionace-glauca.js": [
		17387,
		17387
	],
	"./sharks/carcharhiniformes/carcharhinidae/rhizoprionodon-acutus.js": [
		18813,
		18813
	],
	"./sharks/carcharhiniformes/carcharhinidae/rhizoprionodon-lalandii.js": [
		94756,
		94756
	],
	"./sharks/carcharhiniformes/carcharhinidae/rhizoprionodon-longurio.js": [
		13667,
		13667
	],
	"./sharks/carcharhiniformes/carcharhinidae/rhizoprionodon-oligolinx.js": [
		5728,
		5728
	],
	"./sharks/carcharhiniformes/carcharhinidae/rhizoprionodon-porosus.js": [
		46265,
		46265
	],
	"./sharks/carcharhiniformes/carcharhinidae/rhizoprionodon-taylori.js": [
		50565,
		50565
	],
	"./sharks/carcharhiniformes/carcharhinidae/rhizoprionodon-terraenovae.js": [
		90048,
		90048
	],
	"./sharks/carcharhiniformes/carcharhinidae/scoliodon-laticaudus.js": [
		75179,
		75179
	],
	"./sharks/carcharhiniformes/carcharhinidae/scoliodon-macrorhynchos.js": [
		61222,
		61222
	],
	"./sharks/carcharhiniformes/carcharhinidae/triaenodon-obesus.js": [
		79861,
		79861
	],
	"./sharks/carcharhiniformes/galeocerdo-cuvier.js": [
		51549,
		51549
	],
	"./sharks/carcharhiniformes/gollum-attenuatus.js": [
		81210,
		81210
	],
	"./sharks/carcharhiniformes/hemigaleidae/hemigaleus-australiensis.js": [
		94341,
		94341
	],
	"./sharks/carcharhiniformes/hemigaleidae/hemigaleus-microstoma.js": [
		11424,
		11424
	],
	"./sharks/carcharhiniformes/hemigaleidae/hemipristis-elongata.js": [
		12396,
		12396
	],
	"./sharks/carcharhiniformes/hemigaleidae/paragaleus-pectoralis.js": [
		73076,
		73076
	],
	"./sharks/carcharhiniformes/hemigaleidae/paragaleus-randalli.js": [
		85016,
		85016
	],
	"./sharks/carcharhiniformes/iago-garricki.js": [
		62117,
		62117
	],
	"./sharks/carcharhiniformes/iago-omanensis.js": [
		49114,
		49114
	],
	"./sharks/carcharhiniformes/leptocharias-smithii.js": [
		76513,
		76513
	],
	"./sharks/carcharhiniformes/proscyllium-haberei.js": [
		9818,
		9818
	],
	"./sharks/carcharhiniformes/pseudotriakis-microdon.js": [
		31225,
		31225
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/apristurus-ampliceps.js": [
		16190,
		16190
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/apristurus-australis.js": [
		96401,
		96401
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/apristurus-brunneus.js": [
		21138,
		21138
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/apristurus-exsanguis.js": [
		97162,
		97162
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/apristurus-kampae.js": [
		86348,
		86348
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/apristurus-laurussonii.js": [
		2755,
		2755
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/apristurus-macrorhynchus.js": [
		54155,
		54155
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/apristurus-manis.js": [
		14347,
		14347
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/apristurus-melanoasper.js": [
		80225,
		80225
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/apristurus-platyrhynchus.js": [
		56527,
		56527
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/apristurus-profundorum.js": [
		17923,
		17923
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/apristurus-sinensis.js": [
		27742,
		27742
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/asymbolus-analis.js": [
		9032,
		9032
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/asymbolus-parvus.js": [
		73349,
		73349
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/asymbolus-rubiginosus.js": [
		32858,
		32858
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/bythaelurus-canescens.js": [
		89090,
		89090
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/bythaelurus-dawsoni.js": [
		23841,
		23841
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/figaro-boardmani.js": [
		38419,
		38419
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/galeus-arae.js": [
		8239,
		8239
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/galeus-melastomus.js": [
		6883,
		96359
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/galeus-murinus.js": [
		55186,
		55186
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/galeus-polli.js": [
		98866,
		98866
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/galeus-sauteri.js": [
		22012,
		22012
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/halaelurus-buergeri.js": [
		19443,
		19443
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/halaelurus-lineatus.js": [
		32428,
		32428
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/halaelurus-natalensis.js": [
		10986,
		10986
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/halaelurus-sellus.js": [
		58613,
		58613
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/haploblepharus-edwardsii.js": [
		98586,
		98586
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/holohalaelurus-regani.js": [
		25192,
		25192
	],
	"./sharks/carcharhiniformes/scyliorhinidae-i/parmaturus-xaniurus.js": [
		16276,
		16276
	],
	"./sharks/carcharhiniformes/scyliorhinidae-ii/atelomycterus-marmoratus.js": [
		88972,
		88972
	],
	"./sharks/carcharhiniformes/scyliorhinidae-ii/atelomycterus-marnkalha.js": [
		12977,
		12977
	],
	"./sharks/carcharhiniformes/scyliorhinidae-ii/aulohalaelurus-labiosus.js": [
		19930,
		19930
	],
	"./sharks/carcharhiniformes/scyliorhinidae-ii/schroederichthys-bivius.js": [
		27404,
		27404
	],
	"./sharks/carcharhiniformes/scyliorhinidae-iii/cephaloscyllium-albipinnum.js": [
		97147,
		97147
	],
	"./sharks/carcharhiniformes/scyliorhinidae-iii/cephaloscyllium-hiscosellum.js": [
		54423,
		54423
	],
	"./sharks/carcharhiniformes/scyliorhinidae-iii/cephaloscyllium-laticeps.js": [
		41349,
		41349
	],
	"./sharks/carcharhiniformes/scyliorhinidae-iii/cephaloscyllium-umbratile.js": [
		3165,
		3165
	],
	"./sharks/carcharhiniformes/scyliorhinidae-iii/cephaloscyllium-variegatum.js": [
		70724,
		70724
	],
	"./sharks/carcharhiniformes/scyliorhinidae-iii/cephaloscyllium-ventriosum.js": [
		40625,
		40625
	],
	"./sharks/carcharhiniformes/scyliorhinidae-iii/poroderma-africanum.js": [
		23115,
		23115
	],
	"./sharks/carcharhiniformes/scyliorhinidae-iii/poroderma-pantherinum.js": [
		47785,
		47785
	],
	"./sharks/carcharhiniformes/scyliorhinidae-iii/scyliorhinus-canicula.js": [
		2566,
		2566
	],
	"./sharks/carcharhiniformes/scyliorhinidae-iii/scyliorhinus-capensis.js": [
		12351,
		12351
	],
	"./sharks/carcharhiniformes/scyliorhinidae-iii/scyliorhinus-retifer.js": [
		54039,
		54039
	],
	"./sharks/carcharhiniformes/scyliorhinidae-iii/scyliorhinus-stellaris.js": [
		76590,
		76590
	],
	"./sharks/carcharhiniformes/sphyrnidae/sphyrna-corona.js": [
		75428,
		75428
	],
	"./sharks/carcharhiniformes/sphyrnidae/sphyrna-lewini.js": [
		2654,
		2654
	],
	"./sharks/carcharhiniformes/sphyrnidae/sphyrna-mokarran.js": [
		89259,
		89259
	],
	"./sharks/carcharhiniformes/sphyrnidae/sphyrna-tiburo.js": [
		15896,
		15896
	],
	"./sharks/carcharhiniformes/sphyrnidae/sphyrna-tudes.js": [
		57262,
		57262
	],
	"./sharks/carcharhiniformes/sphyrnidae/sphyrna-zygaena.js": [
		59971,
		59971
	],
	"./sharks/carcharhiniformes/triakidae/furgaleus-macki.js": [
		55936,
		55936
	],
	"./sharks/carcharhiniformes/triakidae/galeorhinus-galeus.js": [
		19655,
		19655
	],
	"./sharks/carcharhiniformes/triakidae/hemitriakis-complicofasciata.js": [
		46323,
		46323
	],
	"./sharks/carcharhiniformes/triakidae/hemitriakis-falcata.js": [
		77475,
		77475
	],
	"./sharks/carcharhiniformes/triakidae/hemitriakis-japanica.js": [
		55377,
		55377
	],
	"./sharks/carcharhiniformes/triakidae/hemitriakis-leucoperiptera.js": [
		43832,
		43832
	],
	"./sharks/carcharhiniformes/triakidae/hypogaleus-hyugaensis.js": [
		61882,
		61882
	],
	"./sharks/carcharhiniformes/triakidae/mustelus-albipinnis.js": [
		17741,
		17741
	],
	"./sharks/carcharhiniformes/triakidae/mustelus-antarcticus.js": [
		86522,
		86522
	],
	"./sharks/carcharhiniformes/triakidae/mustelus-asterias.js": [
		45809,
		45809
	],
	"./sharks/carcharhiniformes/triakidae/mustelus-californicus.js": [
		50603,
		50603
	],
	"./sharks/carcharhiniformes/triakidae/mustelus-canis.js": [
		42918,
		42918
	],
	"./sharks/carcharhiniformes/triakidae/mustelus-henlei.js": [
		87003,
		87003
	],
	"./sharks/carcharhiniformes/triakidae/mustelus-lenticulatus.js": [
		4829,
		4829
	],
	"./sharks/carcharhiniformes/triakidae/mustelus-lunulatus.js": [
		73756,
		73756
	],
	"./sharks/carcharhiniformes/triakidae/mustelus-manazo.js": [
		36449,
		36449
	],
	"./sharks/carcharhiniformes/triakidae/mustelus-mosis.js": [
		15872,
		15872
	],
	"./sharks/carcharhiniformes/triakidae/mustelus-mustelus.js": [
		88268,
		88268
	],
	"./sharks/carcharhiniformes/triakidae/mustelus-norrisi.js": [
		51818,
		51818
	],
	"./sharks/carcharhiniformes/triakidae/mustelus-palumbes.js": [
		40534,
		40534
	],
	"./sharks/carcharhiniformes/triakidae/mustelus-ravidus.js": [
		98680,
		98680
	],
	"./sharks/carcharhiniformes/triakidae/mustelus-schmitti.js": [
		53422,
		53422
	],
	"./sharks/carcharhiniformes/triakidae/mustelus-stevensi.js": [
		75751,
		75751
	],
	"./sharks/carcharhiniformes/triakidae/mustelus-widodoi.js": [
		9772,
		9772
	],
	"./sharks/carcharhiniformes/triakidae/scylliogaleus-quecketti.js": [
		87955,
		87955
	],
	"./sharks/carcharhiniformes/triakidae/triakis-megalopterus.js": [
		83398,
		83398
	],
	"./sharks/carcharhiniformes/triakidae/triakis-scyllium.js": [
		11787,
		11787
	],
	"./sharks/carcharhiniformes/triakidae/triakis-semifasciata.js": [
		55575,
		55575
	],
	"./sharks/echinorhinidae/echinorhinus-brucus.js": [
		73371,
		73371
	],
	"./sharks/echinorhinidae/echinorhinus-cookei.js": [
		56538,
		56538
	],
	"./sharks/heterodontiformes/heterodontus-francisci.js": [
		58447,
		58447
	],
	"./sharks/heterodontiformes/heterodontus-galeatus.js": [
		2531,
		2531
	],
	"./sharks/heterodontiformes/heterodontus-mexicanus.js": [
		20731,
		20731
	],
	"./sharks/heterodontiformes/heterodontus-portusjacksoni.js": [
		67107,
		67107
	],
	"./sharks/heterodontiformes/heterodontus-zebra.js": [
		59819,
		59819
	],
	"./sharks/hexanchiformes/chlamydoselachus-anguineus.js": [
		85603,
		85603
	],
	"./sharks/hexanchiformes/heptranchias-perlo.js": [
		11310,
		11310
	],
	"./sharks/hexanchiformes/hexanchus-griseus.js": [
		61822,
		61822
	],
	"./sharks/hexanchiformes/hexanchus-nakamurai.js": [
		27293,
		27293
	],
	"./sharks/hexanchiformes/hexanchus-vitulus.js": [
		18309,
		18309
	],
	"./sharks/hexanchiformes/notorynchus-cepedianus.js": [
		79162,
		79162
	],
	"./sharks/lamniformes/alopias-pelagicus.js": [
		43423,
		43423
	],
	"./sharks/lamniformes/alopias-superciliosus.js": [
		17185,
		17185
	],
	"./sharks/lamniformes/alopias-vulpinus.js": [
		83346,
		83346
	],
	"./sharks/lamniformes/carcharias-taurus.js": [
		3884,
		3884
	],
	"./sharks/lamniformes/cetorhinus-maximus.js": [
		15066,
		15066
	],
	"./sharks/lamniformes/lamnidae/carcharodon-carcharias.js": [
		60956,
		60956
	],
	"./sharks/lamniformes/lamnidae/isurus-oxyrinchus.js": [
		34065,
		34065
	],
	"./sharks/lamniformes/lamnidae/isurus-paucus.js": [
		11592,
		11592
	],
	"./sharks/lamniformes/lamnidae/lamna-ditropis.js": [
		89137,
		89137
	],
	"./sharks/lamniformes/lamnidae/lamna-nasus.js": [
		97505,
		97505
	],
	"./sharks/lamniformes/megachasma-pelagios.js": [
		34602,
		34602
	],
	"./sharks/lamniformes/mitsukurina-owstoni.js": [
		11058,
		11058
	],
	"./sharks/lamniformes/odontaspis-ferox.js": [
		81226,
		81226
	],
	"./sharks/lamniformes/odontaspis-noronhai.js": [
		42909,
		42909
	],
	"./sharks/lamniformes/pseudocarcharias-kamoharai.js": [
		85186,
		85186
	],
	"./sharks/orectolobiformes/brachaelurus-colcloughi.js": [
		53172,
		53172
	],
	"./sharks/orectolobiformes/brachaelurus-waddi.js": [
		15333,
		15333
	],
	"./sharks/orectolobiformes/ginglymostoma-cirratum.js": [
		89997,
		89997
	],
	"./sharks/orectolobiformes/hemiscylliidae/chiloscyllium-griseum.js": [
		85506,
		85506
	],
	"./sharks/orectolobiformes/hemiscylliidae/chiloscyllium-hasseltii.js": [
		19681,
		19681
	],
	"./sharks/orectolobiformes/hemiscylliidae/chiloscyllium-indicum.js": [
		50710,
		50710
	],
	"./sharks/orectolobiformes/hemiscylliidae/chiloscyllium-plagiosum.js": [
		63397,
		63397
	],
	"./sharks/orectolobiformes/hemiscylliidae/chiloscyllium-punctatum.js": [
		6562,
		6562
	],
	"./sharks/orectolobiformes/hemiscylliidae/hemiscyllium-ocellatum.js": [
		67644,
		67644
	],
	"./sharks/orectolobiformes/nebrius-ferrugineus.js": [
		651,
		651
	],
	"./sharks/orectolobiformes/orectolobidae/eucrossorhinus-dasypogon.js": [
		62038,
		62038
	],
	"./sharks/orectolobiformes/orectolobidae/orectolobus-floridus.js": [
		25479,
		25479
	],
	"./sharks/orectolobiformes/orectolobidae/orectolobus-halei.js": [
		69843,
		69843
	],
	"./sharks/orectolobiformes/orectolobidae/orectolobus-hutchinsi.js": [
		21044,
		21044
	],
	"./sharks/orectolobiformes/orectolobidae/orectolobus-maculatus.js": [
		67670,
		67670
	],
	"./sharks/orectolobiformes/orectolobidae/orectolobus-ornatus.js": [
		44347,
		44347
	],
	"./sharks/orectolobiformes/orectolobidae/orectolobus-parvimaculatus.js": [
		29030,
		29030
	],
	"./sharks/orectolobiformes/parascyllium-collare.js": [
		10225,
		10225
	],
	"./sharks/orectolobiformes/pseudoginglymostoma-brevicaudatum.js": [
		32877,
		32877
	],
	"./sharks/orectolobiformes/rhincodon-typus.js": [
		31937,
		31937
	],
	"./sharks/orectolobiformes/stegostoma-fasciatum.js": [
		9343,
		9343
	],
	"./sharks/pristiophoriformes/pliotrema-warreni.js": [
		94130,
		94130
	],
	"./sharks/pristiophoriformes/pristiophorus-cirratus.js": [
		70805,
		70805
	],
	"./sharks/pristiophoriformes/pristiophorus-japonicus.js": [
		73168,
		73168
	],
	"./sharks/squaliformes/centrophoridae/centrophorus-acus.js": [
		25754,
		25754
	],
	"./sharks/squaliformes/centrophoridae/centrophorus-granulosus.js": [
		92476,
		92476
	],
	"./sharks/squaliformes/centrophoridae/centrophorus-harrissoni.js": [
		1609,
		1609
	],
	"./sharks/squaliformes/centrophoridae/centrophorus-isodon.js": [
		41467,
		41467
	],
	"./sharks/squaliformes/centrophoridae/centrophorus-lusitanicus.js": [
		13404,
		13404
	],
	"./sharks/squaliformes/centrophoridae/centrophorus-moluccensis.js": [
		72712,
		72712
	],
	"./sharks/squaliformes/centrophoridae/centrophorus-squamosus.js": [
		73946,
		73946
	],
	"./sharks/squaliformes/centrophoridae/centrophorus-zeehaani.js": [
		24673,
		24673
	],
	"./sharks/squaliformes/centrophoridae/deania-calcea.js": [
		6152,
		6152
	],
	"./sharks/squaliformes/centrophoridae/deania-profundorum.js": [
		1652,
		1652
	],
	"./sharks/squaliformes/centrophoridae/deania-quadrispinosum.js": [
		48821,
		48821
	],
	"./sharks/squaliformes/dalatiidae/dalatias-licha.js": [
		62892,
		62892
	],
	"./sharks/squaliformes/dalatiidae/euprotomicrus-bispinatus.js": [
		67515,
		67515
	],
	"./sharks/squaliformes/dalatiidae/isistius-brasiliensis.js": [
		12732,
		12732
	],
	"./sharks/squaliformes/dalatiidae/squaliolus-aliae.js": [
		93957,
		93957
	],
	"./sharks/squaliformes/dalatiidae/squaliolus-laticaudus.js": [
		3379,
		3379
	],
	"./sharks/squaliformes/etmopteridae/centroscyllium-fabricii.js": [
		11361,
		11361
	],
	"./sharks/squaliformes/etmopteridae/centroscyllium-granulatum.js": [
		22117,
		22117
	],
	"./sharks/squaliformes/etmopteridae/centroscyllium-nigrum.js": [
		34776,
		34776
	],
	"./sharks/squaliformes/etmopteridae/centroscyllium-ritteri.js": [
		2580,
		2580
	],
	"./sharks/squaliformes/etmopteridae/etmopterus-baxteri.js": [
		81954,
		81954
	],
	"./sharks/squaliformes/etmopteridae/etmopterus-bigelowi.js": [
		85558,
		85558
	],
	"./sharks/squaliformes/etmopteridae/etmopterus-brachyurus.js": [
		87399,
		87399
	],
	"./sharks/squaliformes/etmopteridae/etmopterus-gracilispinis.js": [
		53517,
		53517
	],
	"./sharks/squaliformes/etmopteridae/etmopterus-granulosus.js": [
		9374,
		9374
	],
	"./sharks/squaliformes/etmopteridae/etmopterus-lucifer.js": [
		28816,
		28816
	],
	"./sharks/squaliformes/etmopteridae/etmopterus-molleri.js": [
		46286,
		46286
	],
	"./sharks/squaliformes/etmopteridae/etmopterus-polli.js": [
		62063,
		62063
	],
	"./sharks/squaliformes/etmopteridae/etmopterus-princeps.js": [
		55778,
		55778
	],
	"./sharks/squaliformes/etmopteridae/etmopterus-pusillus.js": [
		65618,
		65618
	],
	"./sharks/squaliformes/etmopteridae/etmopterus-schultzi.js": [
		40542,
		40542
	],
	"./sharks/squaliformes/etmopteridae/etmopterus-sentosus.js": [
		4747,
		4747
	],
	"./sharks/squaliformes/etmopteridae/etmopterus-spinax.js": [
		50831,
		50831
	],
	"./sharks/squaliformes/etmopteridae/etmopterus-splendidus.js": [
		69882,
		69882
	],
	"./sharks/squaliformes/etmopteridae/etmopterus-unicolor.js": [
		38245,
		38245
	],
	"./sharks/squaliformes/etmopteridae/etmopterus-viator.js": [
		40401,
		40401
	],
	"./sharks/squaliformes/etmopteridae/etmopterus-virens.js": [
		4361,
		4361
	],
	"./sharks/squaliformes/etmopteridae/miroscyllium-sheikoi.js": [
		89035,
		89035
	],
	"./sharks/squaliformes/etmopteridae/trigonognathus-kabeyai.js": [
		90687,
		90687
	],
	"./sharks/squaliformes/somniosidae-oxynotidae/centroscymnus-coelolepis.js": [
		61839,
		61839
	],
	"./sharks/squaliformes/somniosidae-oxynotidae/centroscymnus-owstonii.js": [
		13356,
		13356
	],
	"./sharks/squaliformes/somniosidae-oxynotidae/centroselachus-crepidater.js": [
		85200,
		85200
	],
	"./sharks/squaliformes/somniosidae-oxynotidae/oxynotus-bruniensis.js": [
		94211,
		94211
	],
	"./sharks/squaliformes/somniosidae-oxynotidae/oxynotus-paradoxus.js": [
		67303,
		67303
	],
	"./sharks/squaliformes/somniosidae-oxynotidae/proscymnodon-plunketi.js": [
		90492,
		90492
	],
	"./sharks/squaliformes/somniosidae-oxynotidae/scymnodon-ringens.js": [
		62863,
		62863
	],
	"./sharks/squaliformes/somniosidae-oxynotidae/somniosus-microcephalus.js": [
		8506,
		8506
	],
	"./sharks/squaliformes/somniosidae-oxynotidae/somniosus-pacificus.js": [
		51798,
		51798
	],
	"./sharks/squaliformes/somniosidae-oxynotidae/somniosus-rostratus.js": [
		56405,
		56405
	],
	"./sharks/squaliformes/somniosidae-oxynotidae/zameus-squamulosus.js": [
		46601,
		46601
	],
	"./sharks/squaliformes/squalidae/cirrhigaleus-asper.js": [
		80968,
		80968
	],
	"./sharks/squaliformes/squalidae/cirrhigaleus-australis.js": [
		6185,
		6185
	],
	"./sharks/squaliformes/squalidae/squalus-acanthias.js": [
		52863,
		52863
	],
	"./sharks/squaliformes/squalidae/squalus-albifrons.js": [
		69069,
		69069
	],
	"./sharks/squaliformes/squalidae/squalus-brevirostris.js": [
		5366,
		5366
	],
	"./sharks/squaliformes/squalidae/squalus-chloroculus.js": [
		36482,
		36482
	],
	"./sharks/squaliformes/squalidae/squalus-crassispinus.js": [
		74621,
		74621
	],
	"./sharks/squaliformes/squalidae/squalus-cubensis.js": [
		20290,
		20290
	],
	"./sharks/squaliformes/squalidae/squalus-edmundsi.js": [
		80251,
		80251
	],
	"./sharks/squaliformes/squalidae/squalus-grahami.js": [
		121,
		121
	],
	"./sharks/squaliformes/squalidae/squalus-japonicus.js": [
		12878,
		12878
	],
	"./sharks/squaliformes/squalidae/squalus-megalops.js": [
		86485,
		86485
	],
	"./sharks/squaliformes/squalidae/squalus-mitsukurii.js": [
		87671,
		87671
	],
	"./sharks/squaliformes/squalidae/squalus-montalbani.js": [
		20370,
		20370
	],
	"./sharks/squaliformes/squalidae/squalus-nasutus.js": [
		4735,
		4735
	],
	"./sharks/squaliformes/squalidae/squalus-suckleyi.js": [
		98357,
		98357
	],
	"./sharks/squatiniformes/squatina-aculeata.js": [
		94238,
		94238
	],
	"./sharks/squatiniformes/squatina-albipunctata.js": [
		17898,
		17898
	],
	"./sharks/squatiniformes/squatina-californica.js": [
		22014,
		22014
	],
	"./sharks/squatiniformes/squatina-dumeril.js": [
		3669,
		3669
	],
	"./sharks/squatiniformes/squatina-formosa.js": [
		19473,
		19473
	],
	"./sharks/squatiniformes/squatina-oculata.js": [
		53498,
		53498
	],
	"./sharks/squatiniformes/squatina-tergocellatoides.js": [
		12220,
		12220
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 72748;
module.exports = webpackAsyncContext;